"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.settings.chunkSize.label': 'Rozmiar Fragmentu',
    'rag.settings.chunkSize.description': 'Rozmiar fragmentów tekstu do indeksowania (100-2000 znaków)',
    'rag.settings.chunkOverlap.label': 'Nakładanie Fragmentów',
    'rag.settings.chunkOverlap.description': 'Nakładanie między fragmentami w celu zachowania kontekstu (0-500 znaków)',
    'rag.settings.similarityThreshold.label': 'Próg Podobieństwa',
    'rag.settings.similarityThreshold.description': 'Minimalny wynik podobieństwa dla rezultatów wyszukiwania (0.1-1.0)',
    'rag.settings.defaultMaxResults.label': 'Domyślna Maks. Liczba Wyników',
    'rag.settings.defaultMaxResults.description': 'Domyślna liczba wyników wyszukiwania do zwrócenia (1-20)',
    'rag.settings.maxResults.label': 'Maksymalne Wyniki',
    'rag.settings.maxResults.description': 'Maksymalna liczba dozwolonych wyników wyszukiwania (1-20)',
    'rag.settings.separators.label': 'Separatory Tekstu',
    'rag.settings.separators.description': 'Znaki używane do dzielenia tekstu na fragmenty',
    'rag.settings.separators.placeholder': 'Wprowadź separator',
    'rag.settings.separators.add': 'Dodaj Separator',
    'rag.settings.resetToDefaults.label': 'Przywróć Domyślne',
    'rag.settings.resetToDefaults.tooltip': 'Przywróć ustawienia RAG do wartości domyślnych',
};
